// extracted by mini-css-extract-plugin
module.exports = {"btn":"ProfileInfoForm_btn__1xqfP","form":"ProfileInfoForm_form__z4kHx"};